import { Card, Skeleton, Stack } from '@mui/material'
import { SkeletonText } from 'utoniq-ui'

export const CollectionSelectBoxSkeleton = () => {
  return (
    <Card elevation={0} sx={{ borderRadius: 0, bgcolor: 'unset' }}>
      <Stack flex={1} direction="row" spacing={4} alignItems="center">
        <Skeleton variant="rectangular" sx={{ height: 90, width: 120 }} />
        <Stack flex={1}>
          <SkeletonText variant="medium" width="75%" />
          <SkeletonText variant="small" width="50%" />
        </Stack>
      </Stack>
    </Card>
  )
}
